<!-- <ion-button *ngFor="let number of scale" (click)="rate(number)">
    <ion-icon name="star-sharp" [ngStyle]="{'color':'getColor(number)'}"> </ion-icon>
</ion-button> -->


<div class="ionic5-star-rating pb-8">
    <!-- <ion-button > -->
    <ion-icon [ngStyle]="{'height' : fontSize}" *ngFor="let index of iconsArray; trackBy: trackById" id="{{index}}" [ngStyle]="{'color': rating && index < rating ? activeColor : defaultColor}" (click)="changeRating($event)" name="{{index < rating ? activeIcon : defaultIcon}}"></ion-icon>
    <!-- </ion-button> -->
</div>